module.exports = __webpack_public_path__ + "media/images/external-f7f02142.svg";